import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  InputAdornment,
} from '@mui/material';

const NumberInputDialog = ({ tittle = "Apertura de Caja", label = "Monto inicial", open, onClose, onConfirm, disablePortal = false }) => {
  const [amount, setAmount] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    const value = parseInt(amount);
    if (isNaN(value) || value < 0) {
      setError('Ingrese un monto válido mayor o igual a 0');
      return;
    }
    setError('');
    onConfirm(value);
    setAmount('');
  };

  const handleClose = () => {
    setAmount('');
    setError('');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      disablePortal={disablePortal}
      container={disablePortal ? () => document.querySelector('[data-tab-content="true"]') : undefined}
      style={disablePortal ? { position: 'absolute' } : undefined}
      BackdropProps={disablePortal ? { style: { position: 'absolute' } } : undefined}
    >
      <DialogTitle>{tittle}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          margin="dense"
          label={label}
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleConfirm} variant="contained" color="primary">
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NumberInputDialog;
